import React, {Component} from 'react'
import {isEmpty} from 'lodash'
import 'video.js/dist/video-js.css'
import ThemeVideoPlayer from "./ThemeVideoPlayer";
import {Modal} from 'antd-mobile'
import styled from 'styled-components'
import get from 'lodash/get'

const videoJsOptions = (src) => {
  return {
    autoplay: false,
    controls: true,
    height: '100%',
    sources: [
      {
        src: src,
        type: 'video/mp4'
      }
    ],
    // poster: blog.avatar
  }
}

export class VideoItem extends Component {

  state = {
    visible: false,
    shareModal:false,
  }

  isShow = () => {
    setTimeout(() => {
        this.setState({shareModal:false})
    }, 2000)
  }

  playVideo = (index) => {
    const playVideo =this.props.props.shareActivity.shareActivity.meShare || this.props.unLocked
    if(!playVideo){
      this.setState({shareModal:true},()=>{this.isShow()})
      return
    }
    this.setState({url: this.props.themeVideo[index].url}, () => this.setState({visible: true}))
    const mutate = this.props.props.playVideoCount
      const theme = get(this.props.props, 'theme.theme')
      const activityId = theme.themes[1]._id
      const patientId = get(this.props.props, 'match.params.patientId')
      const systemType = get(this.props.props, 'match.params.systemType', 'BG')
      const variables = {
        activityId,
        systemType,
        patientId,
        themeId: theme._id,
      }
      mutate({
        variables,
      })
        .then(res => {
          console.log('open video', res)
        })
        .catch(e => {
          console.log('catch a error', e)
        })
  }
  closePlayer = () => {
    this.setState({visible: false})
  }
  render() {
    const themeVideo = this.props.themeVideo
    let image =[require('./images/video1.png'),require('./images/video2.png'),require('./images/video3.png')]
    const meShare = get(this.props.props, 'shareActivity.shareActivity.meShare', false)
    const playVideo = meShare || this.props.unLocked
    if(playVideo){
      image=[require('./images/playVideo1.png'),require('./images/playVideo2.png'),require('./images/playVideo3.png')]
    }
        return (
      <div>
       <Modal
      visible={this.state.shareModal}
       transparent
         maskClosable={false}
      >
      <div style={{flexDirection:'column',display:'flex',alignItems:'center',flex:1,padding:'15px'}}>
        <img
              style={{height: '149px', width: '240px'}}
              src={require('./images/sharegroup.png')}
            />
           <div style={{color:'#FA7268',marginTop:'30px'}}>您还没有邀请好友哦~ </div>
           <div style={{color:'#FA7268'}}>下滑页面点击『邀请好友』按钮 </div>
           <div style={{color:'#FA7268'}}>快邀请小伙伴一起来 </div>
      </div>
    </Modal>
      <ModalView
          visible={this.state.visible}
          transparent
          maskClosable={false}
        >
          <div style={{
            flex: 1,
            display: 'flex',
            backgroundColor: 'black',
            justifyContext: 'center',
            alignItems: 'center',
            flexDirection: 'column'
          }}>
            <img
              onClick={this.closePlayer}
              style={{height: '20px', position: 'absolute', top: 0, right: 38, width: '20px'}}
              src={require('./images/icon_close.png')}
            />
            <ThemeVideoPlayer {...videoJsOptions(this.state.url)}/>
          </div>
        </ModalView>
        <div>
          {!isEmpty(themeVideo) &&
          themeVideo.map((item, index) => {
            const contentHtml = {
              __html: item.title
            }
            const contentHtml1 = {
              __html: item.desc
            }
            return (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  padding: 10,
                  marginTop: 8,
                  borderRadius: 6,
                  flexDirection: 'row',
                  backgroundColor: '#FFE4CA',
                }}
              >
                <img
                  onClick={() => this.playVideo(index)}
                  src={image[index]}
                  style={{flex: '0', width: '42%', maxWidth: '140px'}}
                />
                <div >
                <div dangerouslySetInnerHTML={contentHtml}/>
                <div dangerouslySetInnerHTML={contentHtml1}/>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

const ModalView = styled(Modal)`
  &.am-modal-transparent{
      width:100%;
      height:260px;
      justify-content:center
    .am-modal-content{
       padding:0;
       align-items:center;
       justify-content:center
       display:flex;
       background-color:rgba(0,0,0,0) !important;
      .am-modal-body {
       padding:0;
       justify-content:center
       align-items:center;
       display:flex;
       .video-js{
        .vjs-big-play-button{
          top: 40%;
          left: 40%;
        }
       }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/modules/theme/components/videoItem.js